import MessageBox from "sap/m/MessageBox";
import MessageToast from "sap/m/MessageToast";
import type ResourceBundle from "sap/base/i18n/ResourceBundle";

export interface InviteUserResponse {
	userId: string;
	invitationToken: string;
	expiresAt: string;
	/** True when the invitee is CompuTec staff: no e-mail was sent, they sign in with Microsoft. */
	staffBrokerLogin?: boolean;
}

/** The success message of an invitation; staff invitations send no e-mail (spec 29 D-079). */
export function inviteSuccessText(bundle: ResourceBundle, response: InviteUserResponse): string {
	return response.staffBrokerLogin === true
		? bundle.getText("organization.detail.users.dialog.successStaff") ?? ""
		: bundle.getText("organization.detail.users.dialog.success") ?? "";
}

/**
 * Reports the outcome of a successful invitation: a toast, plus - for non-staff invitees only -
 * the invitation token in a dialog (no e-mail is sent in dev, so the token is shown for manual tests).
 */
export function showInviteOutcome(bundle: ResourceBundle, response: InviteUserResponse): void {
	MessageToast.show(inviteSuccessText(bundle, response));

	if (response.staffBrokerLogin !== true) {
		MessageBox.information(
			`${bundle.getText("organization.detail.users.dialog.tokenInfo") ?? "Invitation token (dev)"}:\n${response.invitationToken}`,
			{ title: bundle.getText("organization.detail.users.dialog.tokenTitle") ?? "Invitation created" }
		);
	}
}
